export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/0c7f90dcab4574f291a5b93f31621815.svg";